import { useMemo, useState, useRef, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ModalOk } from "../../components/ui/modal/ModalOk"
import { msg } from "../../components/ui/modal/utils"
import { Paginator } from "../../components/ui/Paginator"

import { config } from "../../config"
import { AsyncButton } from "../../components/ui/AsyncButton"
import { ModalEliminarConsigna } from "../../components/admin/ModalEliminarConsigna"
import { ModalEditarConsigna } from "../../components/admin/ModalEditarConsigna"
import { ModalCompartir } from "../../components/admin/ModalCompartir"
import { Trans, useTranslation } from "react-i18next"
import { kebabify } from "../../helpers/utils"

export const AgregarConsigna = ({ setMenu }) => {
  // elements
  const form = useRef()

  // estado
  const [titulo, setTitulo] = useState("")

  // pal msg de ok
  const [cache, setCache] = useState("")

  const createConsigna = useQuery(),
    showRes = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setCache(titulo)
    setTitulo("")
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = api.consignas.create({
      token: getCookie("jwt"),
      cons: [
        {
          titulo,
        },
      ],
    })

    createConsigna.url.current = url
    createConsigna.opt.current = opt
    createConsigna.run({
      onOk: cleanForm,
    })
  }

  const { t } = useTranslation()

  return (
    <>
      {createConsigna.res && !createConsigna.err && (
        <ModalOk
          show={showRes}
          body={msg(
            <Trans
              i18nKey="admin.exercises.exercise_added_succesfully"
              values={{ consigna: cache }}
              components={{ i: <i /> }}
            />
          )}
          onClick={() => setMenu(kebabify(t(`admin.menu.exercises.manage`)))}
        />
      )}

      {createConsigna.res && createConsigna.err && (
        <ModalError id="err-res" show={showRes} res={createConsigna.res} />
      )}

      <div className="col-lg-8 col-12" style={{ margin: "0 auto" }}>
        <div className="col-lg-8 col-12" style={{ margin: "0 auto" }}>
          <form ref={form}>
            <fieldset>
              <legend>{t(`admin.exercises.add_exercise`)}</legend>

              <div className="form-group">
                <label className="form-label mt-4">
                  {t(`admin.exercises.title`)}
                </label>
                <input
                  onChange={(e) => setTitulo(e.target.value)}
                  className="form-control"
                  placeholder={t(`admin.exercises.title_placeholder`)}
                />
              </div>

              <br />

              <AsyncButton
                onClick={onSubmitForm.bind(this)}
                disabled={createConsigna.isPending}
                sending={createConsigna.isPending}
              />
            </fieldset>
          </form>
        </div>
      </div>
    </>
  )
}

export const GestionarConsignas = () => {
  const { t } = useTranslation()

  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1),
    [matching, setMatching] = useState("")

  // edit/delete word

  const [selected, setSelected] = useState(null),
    modalEliminar = useState(false),
    modalEditar = useState(false),
    modalCompartir = useState(false),
    [link, setLink] = useState(null)

  const onClickEditar = (entry, e) => {
    e.preventDefault()
    modalEditar[1](true)
    setSelected(entry)
  }

  const make_url = (con) => `${config.base}/consigna/${con.id}`

  const onClickCopy = (consigna, e) => {
    e.preventDefault()
    setLink(make_url(consigna))
    modalCompartir[1](true)
  }

  const onClickEliminar = (entry, e) => {
    e.preventDefault()
    setSelected(entry)
    modalEliminar[1](true)
  }

  const tkn = getCookie("jwt"),
    { url, opt } = useMemo(
      () =>
        api.consignas.readAll({
          token: tkn,
          from: offest,
          limit,
          match: matching,
        }),
      [limit, offest, matching, tkn]
    )
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const ListConsignas = (consignas) => {
    // return JSON.stringify(consignas)
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>{t(`ui.tables.title`)}</th>
            <th>{t(`ui.tables.author`)}</th>
            <th>{t(`admin.exercises.answers`)}</th>
            <th>{t(`ui.tables.date`)}</th>
            <th>
              <center>{t(`ui.tables.share`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.edit`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {consignas.map((con, ix) => (
            //aca en realidad deberia ser con.id, que lo tiene, pero habria que hacer de nuevo esta parte.
            <tr key={ix}>
              <td>
                <a href={`consigna/${con.id}`} target="_blank" rel="noreferrer">
                  {con.titulo}
                </a>
              </td>
              <td>
                <i>{con.autor.username}</i>
              </td>
              <td>{con.respuestas.length}</td>
              <td>
                <small>{con.timestamp.substring(0, 10)}</small>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickCopy.bind(this, con)}
                    className="btn btn-sm tooltip copy-tooltip"
                  >
                    📋
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEditar.bind(this, con)}
                    className="btn btn-sm tooltip edit-tooltip"
                  >
                    ✏️
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, con)}
                    className="btn btn-sm tooltip elim-tooltip"
                  >
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEditar[0] && (
        <ModalEditarConsigna
          show={modalEditar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalEliminar[0] && (
        <ModalEliminarConsigna
          show={modalEliminar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalCompartir[0] && (
        <ModalCompartir show={modalCompartir} link={link} />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.menu.exercises.manage`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                style={{ fontSize: "14px" }}
              >
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim} selected={lim === limit}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-control form-control-sm"
                style={{ width: "10vw" }}
                type="text"
                onChange={(e) => setMatching(e.target.value)}
                placeholder={t(`ui.tables.filter`)}
              />
            </label>
          </div>
        </div>

        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListConsignas(data.entries)}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={9}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}
